import {
  Companion_getInstance20myouriyv3u as Companion_getInstance,
  ItemChangee3c665suy3yz as ItemChange,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { MonetaryValue3pm7jom4inigc as MonetaryValue } from './supportModels.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(ItemChange_project_getInstance());
}
function prepareItemChangeFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ItemChange__id_getInstance(), ItemChange_project_getInstance(), ItemChange_changeRequest_getInstance(), ItemChange_itemId_getInstance(), ItemChange_linked_getInstance(), ItemChange_updatedDescription_getInstance(), ItemChange_priceChange_getInstance(), ItemChange_cancelled_getInstance(), ItemChange_created_getInstance(), ItemChange_itemNumber_getInstance(), ItemChange_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ItemChange_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ItemChange_project$_get_name_$ref_kxgb2i() {
  return (p0) => p0.k20();
}
function ItemChange_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_project$_get_serializer_$ref_2tczap() {
  return (p0) => p0.j2j();
}
function ItemChange_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ItemChange_project$_get_annotations_$ref_wcreqz() {
  return (p0) => p0.bz();
}
var ItemChange_projectClass;
function ItemChange_project() {
  if (ItemChange_projectClass === VOID) {
    class $ {
      constructor() {
        ItemChange_project_instance = this;
        var tmp = this;
        tmp.t6a_1 = lazy(ItemChange_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u6a_1 = lazy(ItemChange_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v6a_1 = lazy(ItemChange_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_project$_get_name_$ref_kxgb2i(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.y6a_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      i6b(receiver, value) {
        return receiver.j6b(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.i6b(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_project$_get_serializer_$ref_2tczap(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v6a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_project$_get_annotations_$ref_wcreqz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_project', VOID, VOID, [SerializableProperty()]);
    ItemChange_projectClass = $;
  }
  return ItemChange_projectClass;
}
var ItemChange_project_instance;
function ItemChange_project_getInstance() {
  if (ItemChange_project_instance === VOID)
    new (ItemChange_project())();
  return ItemChange_project_instance;
}
function ItemChange__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ItemChange__id$_get_name_$ref_qa3cj9() {
  return (p0) => p0.k20();
}
function ItemChange__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange__id$_get_serializer_$ref_jrk1pu() {
  return (p0) => p0.j2j();
}
function ItemChange__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ItemChange__id$_get_annotations_$ref_ag1y0m() {
  return (p0) => p0.bz();
}
var ItemChange__idClass;
function ItemChange__id() {
  if (ItemChange__idClass === VOID) {
    class $ {
      constructor() {
        ItemChange__id_instance = this;
        var tmp = this;
        tmp.k6b_1 = lazy(ItemChange__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l6b_1 = lazy(ItemChange__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m6b_1 = lazy(ItemChange__id$annotations$delegate$lambda);
        this.n6b_1 = Companion_getInstance_0().m2p();
        this.o6b_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.k6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange__id$_get_name_$ref_qa3cj9(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.x6a_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      i6b(receiver, value) {
        return receiver.j6b(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.i6b(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange__id$_get_serializer_$ref_jrk1pu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange__id$_get_annotations_$ref_ag1y0m(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange__id', VOID, VOID, [SerializableProperty()]);
    ItemChange__idClass = $;
  }
  return ItemChange__idClass;
}
var ItemChange__id_instance;
function ItemChange__id_getInstance() {
  if (ItemChange__id_instance === VOID)
    new (ItemChange__id())();
  return ItemChange__id_instance;
}
function ItemChange_changeRequest$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ItemChange_changeRequest$_get_name_$ref_gqsay8() {
  return (p0) => p0.k20();
}
function ItemChange_changeRequest$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_changeRequest$_get_serializer_$ref_trzb13() {
  return (p0) => p0.j2j();
}
function ItemChange_changeRequest$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ItemChange_changeRequest$_get_annotations_$ref_fsmurp() {
  return (p0) => p0.bz();
}
var ItemChange_changeRequestClass;
function ItemChange_changeRequest() {
  if (ItemChange_changeRequestClass === VOID) {
    class $ {
      constructor() {
        ItemChange_changeRequest_instance = this;
        var tmp = this;
        tmp.p6b_1 = lazy(ItemChange_changeRequest$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q6b_1 = lazy(ItemChange_changeRequest$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r6b_1 = lazy(ItemChange_changeRequest$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.p6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_changeRequest$_get_name_$ref_gqsay8(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.z6a_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      i6b(receiver, value) {
        return receiver.j6b(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.i6b(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_changeRequest$_get_serializer_$ref_trzb13(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_changeRequest$_get_annotations_$ref_fsmurp(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_changeRequest', VOID, VOID, [SerializableProperty()]);
    ItemChange_changeRequestClass = $;
  }
  return ItemChange_changeRequestClass;
}
var ItemChange_changeRequest_instance;
function ItemChange_changeRequest_getInstance() {
  if (ItemChange_changeRequest_instance === VOID)
    new (ItemChange_changeRequest())();
  return ItemChange_changeRequest_instance;
}
function ItemChange_itemId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ItemChange_itemId$_get_name_$ref_72fhcn() {
  return (p0) => p0.k20();
}
function ItemChange_itemId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_itemId$_get_serializer_$ref_lkzssi() {
  return (p0) => p0.j2j();
}
function ItemChange_itemId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ItemChange_itemId$_get_annotations_$ref_dp488y() {
  return (p0) => p0.bz();
}
var ItemChange_itemIdClass;
function ItemChange_itemId() {
  if (ItemChange_itemIdClass === VOID) {
    class $ {
      constructor() {
        ItemChange_itemId_instance = this;
        var tmp = this;
        tmp.s6b_1 = lazy(ItemChange_itemId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t6b_1 = lazy(ItemChange_itemId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u6b_1 = lazy(ItemChange_itemId$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.s6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_itemId$_get_name_$ref_72fhcn(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.a6b_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      i6b(receiver, value) {
        return receiver.j6b(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.i6b(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.t6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_itemId$_get_serializer_$ref_lkzssi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_itemId$_get_annotations_$ref_dp488y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_itemId', VOID, VOID, [SerializableProperty()]);
    ItemChange_itemIdClass = $;
  }
  return ItemChange_itemIdClass;
}
var ItemChange_itemId_instance;
function ItemChange_itemId_getInstance() {
  if (ItemChange_itemId_instance === VOID)
    new (ItemChange_itemId())();
  return ItemChange_itemId_instance;
}
function ItemChange_linked$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ItemChange_linked$_get_name_$ref_rix1tu() {
  return (p0) => p0.k20();
}
function ItemChange_linked$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_linked$_get_serializer_$ref_m207qh() {
  return (p0) => p0.j2j();
}
function ItemChange_linked$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ItemChange_linked$_get_annotations_$ref_ah8tfx() {
  return (p0) => p0.bz();
}
var ItemChange_linkedClass;
function ItemChange_linked() {
  if (ItemChange_linkedClass === VOID) {
    class $ {
      constructor() {
        ItemChange_linked_instance = this;
        var tmp = this;
        tmp.v6b_1 = lazy(ItemChange_linked$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w6b_1 = lazy(ItemChange_linked$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x6b_1 = lazy(ItemChange_linked$annotations$delegate$lambda);
        this.y6b_1 = false;
        this.z6b_1 = 'false';
      }
      k20() {
        var tmp0 = this.v6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_linked$_get_name_$ref_rix1tu(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.b6b_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      a6c(receiver, value) {
        return receiver.j6b(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.a6c(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_linked$_get_serializer_$ref_m207qh(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x6b_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_linked$_get_annotations_$ref_ah8tfx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_linked', VOID, VOID, [SerializableProperty()]);
    ItemChange_linkedClass = $;
  }
  return ItemChange_linkedClass;
}
var ItemChange_linked_instance;
function ItemChange_linked_getInstance() {
  if (ItemChange_linked_instance === VOID)
    new (ItemChange_linked())();
  return ItemChange_linked_instance;
}
function ItemChange_updatedDescription$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ItemChange_updatedDescription$_get_name_$ref_pubusq() {
  return (p0) => p0.k20();
}
function ItemChange_updatedDescription$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_updatedDescription$_get_serializer_$ref_t96f8v() {
  return (p0) => p0.j2j();
}
function ItemChange_updatedDescription$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ItemChange_updatedDescription$_get_annotations_$ref_wlmnkb() {
  return (p0) => p0.bz();
}
var ItemChange_updatedDescriptionClass;
function ItemChange_updatedDescription() {
  if (ItemChange_updatedDescriptionClass === VOID) {
    class $ {
      constructor() {
        ItemChange_updatedDescription_instance = this;
        var tmp = this;
        tmp.b6c_1 = lazy(ItemChange_updatedDescription$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c6c_1 = lazy(ItemChange_updatedDescription$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d6c_1 = lazy(ItemChange_updatedDescription$annotations$delegate$lambda);
        this.e6c_1 = null;
        this.f6c_1 = 'null';
      }
      k20() {
        var tmp0 = this.b6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_updatedDescription$_get_name_$ref_pubusq(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.c6b_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      g6c(receiver, value) {
        return receiver.j6b(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.g6c(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_updatedDescription$_get_serializer_$ref_t96f8v(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_updatedDescription$_get_annotations_$ref_wlmnkb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_updatedDescription', VOID, VOID, [SerializableProperty()]);
    ItemChange_updatedDescriptionClass = $;
  }
  return ItemChange_updatedDescriptionClass;
}
var ItemChange_updatedDescription_instance;
function ItemChange_updatedDescription_getInstance() {
  if (ItemChange_updatedDescription_instance === VOID)
    new (ItemChange_updatedDescription())();
  return ItemChange_updatedDescription_instance;
}
function ItemChange_priceChange$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function ItemChange_priceChange$_get_name_$ref_vh8ci2() {
  return (p0) => p0.k20();
}
function ItemChange_priceChange$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_priceChange$_get_serializer_$ref_5wj09b() {
  return (p0) => p0.j2j();
}
function ItemChange_priceChange$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function ItemChange_priceChange$_get_annotations_$ref_oug1jp() {
  return (p0) => p0.bz();
}
var ItemChange_priceChangeClass;
function ItemChange_priceChange() {
  if (ItemChange_priceChangeClass === VOID) {
    class $ {
      constructor() {
        ItemChange_priceChange_instance = this;
        var tmp = this;
        tmp.h6c_1 = lazy(ItemChange_priceChange$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i6c_1 = lazy(ItemChange_priceChange$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j6c_1 = lazy(ItemChange_priceChange$annotations$delegate$lambda);
        this.k6c_1 = null;
        this.l6c_1 = 'null';
      }
      k20() {
        var tmp0 = this.h6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_priceChange$_get_name_$ref_vh8ci2(), null);
        return tmp0.f2();
      }
      m6c(receiver) {
        return receiver.d6b_1;
      }
      m2j(receiver) {
        var tmp = this.m6c(receiver instanceof ItemChange() ? receiver : THROW_CCE());
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }
      n6c(receiver, value) {
        return receiver.j6b(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof MonetaryValue()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.a5s_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.n6c(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.i6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_priceChange$_get_serializer_$ref_5wj09b(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_priceChange$_get_annotations_$ref_oug1jp(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_priceChange', VOID, VOID, [SerializableProperty()]);
    ItemChange_priceChangeClass = $;
  }
  return ItemChange_priceChangeClass;
}
var ItemChange_priceChange_instance;
function ItemChange_priceChange_getInstance() {
  if (ItemChange_priceChange_instance === VOID)
    new (ItemChange_priceChange())();
  return ItemChange_priceChange_instance;
}
function ItemChange_cancelled$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function ItemChange_cancelled$_get_name_$ref_748ite() {
  return (p0) => p0.k20();
}
function ItemChange_cancelled$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_cancelled$_get_serializer_$ref_54rml3() {
  return (p0) => p0.j2j();
}
function ItemChange_cancelled$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function ItemChange_cancelled$_get_annotations_$ref_xv9ot() {
  return (p0) => p0.bz();
}
var ItemChange_cancelledClass;
function ItemChange_cancelled() {
  if (ItemChange_cancelledClass === VOID) {
    class $ {
      constructor() {
        ItemChange_cancelled_instance = this;
        var tmp = this;
        tmp.o6c_1 = lazy(ItemChange_cancelled$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p6c_1 = lazy(ItemChange_cancelled$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q6c_1 = lazy(ItemChange_cancelled$annotations$delegate$lambda);
        this.r6c_1 = false;
        this.s6c_1 = 'false';
      }
      k20() {
        var tmp0 = this.o6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_cancelled$_get_name_$ref_748ite(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.e6b_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      a6c(receiver, value) {
        return receiver.j6b(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.a6c(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_cancelled$_get_serializer_$ref_54rml3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_cancelled$_get_annotations_$ref_xv9ot(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_cancelled', VOID, VOID, [SerializableProperty()]);
    ItemChange_cancelledClass = $;
  }
  return ItemChange_cancelledClass;
}
var ItemChange_cancelled_instance;
function ItemChange_cancelled_getInstance() {
  if (ItemChange_cancelled_instance === VOID)
    new (ItemChange_cancelled())();
  return ItemChange_cancelled_instance;
}
function ItemChange_created$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function ItemChange_created$_get_name_$ref_p6q2ex() {
  return (p0) => p0.k20();
}
function ItemChange_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_created$_get_serializer_$ref_3k56ao() {
  return (p0) => p0.j2j();
}
function ItemChange_created$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function ItemChange_created$_get_annotations_$ref_fm2m90() {
  return (p0) => p0.bz();
}
var ItemChange_createdClass;
function ItemChange_created() {
  if (ItemChange_createdClass === VOID) {
    class $ {
      constructor() {
        ItemChange_created_instance = this;
        var tmp = this;
        tmp.t6c_1 = lazy(ItemChange_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u6c_1 = lazy(ItemChange_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v6c_1 = lazy(ItemChange_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.w6c_1 = get_default(Companion_instance).d1m();
        this.x6c_1 = 'now()';
      }
      k20() {
        var tmp0 = this.t6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_created$_get_name_$ref_p6q2ex(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.f6b_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      y6c(receiver, value) {
        return receiver.j6b(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.y6c(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_created$_get_serializer_$ref_3k56ao(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_created$_get_annotations_$ref_fm2m90(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_created', VOID, VOID, [SerializableProperty()]);
    ItemChange_createdClass = $;
  }
  return ItemChange_createdClass;
}
var ItemChange_created_instance;
function ItemChange_created_getInstance() {
  if (ItemChange_created_instance === VOID)
    new (ItemChange_created())();
  return ItemChange_created_instance;
}
function ItemChange_itemNumber$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function ItemChange_itemNumber$_get_name_$ref_ep0pvp() {
  return (p0) => p0.k20();
}
function ItemChange_itemNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_itemNumber$_get_serializer_$ref_47t0gk() {
  return (p0) => p0.j2j();
}
function ItemChange_itemNumber$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function ItemChange_itemNumber$_get_annotations_$ref_rfxs7k() {
  return (p0) => p0.bz();
}
var ItemChange_itemNumberClass;
function ItemChange_itemNumber() {
  if (ItemChange_itemNumberClass === VOID) {
    class $ {
      constructor() {
        ItemChange_itemNumber_instance = this;
        var tmp = this;
        tmp.z6c_1 = lazy(ItemChange_itemNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a6d_1 = lazy(ItemChange_itemNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b6d_1 = lazy(ItemChange_itemNumber$annotations$delegate$lambda);
        this.c6d_1 = '1';
        this.d6d_1 = '"1"';
      }
      k20() {
        var tmp0 = this.z6c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_itemNumber$_get_name_$ref_ep0pvp(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.g6b_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      e6d(receiver, value) {
        return receiver.j6b(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.e6d(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_itemNumber$_get_serializer_$ref_47t0gk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_itemNumber$_get_annotations_$ref_rfxs7k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_itemNumber', VOID, VOID, [SerializableProperty()]);
    ItemChange_itemNumberClass = $;
  }
  return ItemChange_itemNumberClass;
}
var ItemChange_itemNumber_instance;
function ItemChange_itemNumber_getInstance() {
  if (ItemChange_itemNumber_instance === VOID)
    new (ItemChange_itemNumber())();
  return ItemChange_itemNumber_instance;
}
function ItemChange_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function ItemChange_readBy$_get_name_$ref_3wb88m() {
  return (p0) => p0.k20();
}
function ItemChange_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ItemChange_readBy$_get_serializer_$ref_kq8dlv() {
  return (p0) => p0.j2j();
}
function ItemChange_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function ItemChange_readBy$_get_annotations_$ref_cshugv() {
  return (p0) => p0.bz();
}
var ItemChange_readByClass;
function ItemChange_readBy() {
  if (ItemChange_readByClass === VOID) {
    class $ {
      constructor() {
        ItemChange_readBy_instance = this;
        var tmp = this;
        tmp.f6d_1 = lazy(ItemChange_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g6d_1 = lazy(ItemChange_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h6d_1 = lazy(ItemChange_readBy$annotations$delegate$lambda);
        this.i6d_1 = emptySet();
        this.j6d_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.f6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ItemChange_readBy$_get_name_$ref_3wb88m(), null);
        return tmp0.f2();
      }
      w6a(receiver) {
        return receiver.h6b_1;
      }
      m2j(receiver) {
        return this.w6a(receiver instanceof ItemChange() ? receiver : THROW_CCE());
      }
      k6d(receiver, value) {
        return receiver.j6b(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ItemChange() ? receiver : THROW_CCE();
        return this.k6d(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ItemChange_readBy$_get_serializer_$ref_kq8dlv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ItemChange_readBy$_get_annotations_$ref_cshugv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ItemChange_readBy', VOID, VOID, [SerializableProperty()]);
    ItemChange_readByClass = $;
  }
  return ItemChange_readByClass;
}
var ItemChange_readBy_instance;
function ItemChange_readBy_getInstance() {
  if (ItemChange_readBy_instance === VOID)
    new (ItemChange_readBy())();
  return ItemChange_readBy_instance;
}
//region block: exports
export {
  prepareItemChangeFields as prepareItemChangeFields3jbtyyrhv73f3,
  get_project as get_project1h3ocr37wkxs4,
};
//endregion

//# sourceMappingURL=ItemChangeFields.mjs.map
